import { render, staticRenderFns } from "./FederatedEmailLogin.vue?vue&type=template&id=f7a94f18"
import script from "./FederatedEmailLogin.vue?vue&type=script&lang=js"
export * from "./FederatedEmailLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports